import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import IconButton from "@mui/material/IconButton";
import { useTheme, type SxProps } from "@mui/material/styles";
import type { TableCellProps } from "@mui/material/TableCell";
import TableCell from "@mui/material/TableCell";
import { useMemo } from "react";

import { getExpandToggleIconButtonSx } from "./get-expand-toggle-icon-button.sx";

type ExpandableTableCellProps = {
  open?: boolean;
  iconSx?: SxProps;
  isHidden?: boolean;
  setOpen?: (value: boolean) => void;
};
export default function ExpandableTableCell({
  open,
  isHidden,
  setOpen,
  iconSx,
  sx,
}: TableCellProps & ExpandableTableCellProps) {
  const theme = useTheme();
  const cellSx = useMemo(
    () => ({ ...sx, display: isHidden ? "none" : undefined }),
    [isHidden, sx]
  );
  return (
    <TableCell sx={cellSx}>
      <IconButton
        sx={getExpandToggleIconButtonSx(theme, { mr: 1.5, ...iconSx })}
        onClick={() => {
          setOpen?.(!open);
        }}
      >
        {!open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
      </IconButton>
    </TableCell>
  );
}
